import $ from 'jquery';
import debounce from 'lodash/debounce';
import eventManager from '~/js/managers/event-manager';


const Layout = function () {
    let self, eventTypes, breakpoints, internal, elements, fn, handlers;

    self = this;

    eventTypes = {
        RESIZE: 'layoutResize'
    };

    // enum of possible breakpoints
    // these values correspond to breakpoint rules
    // defined in layout/_responsive.scss
    // NB: this approach assumes no overlap in these breakpoints
    breakpoints = {
        PHONE: {
            name: 'PHONE',
            maxWidth: 640
        },
        TABLET: {
            name: 'TABLET',
            minWidth: 641,
            maxWidth: 1024
        },
        FULL: {
            name: 'FULL',
            minWidth: 1025
        }
    };

    internal = {
        // info is cached internally to allow multiple calls to getInfo
        // without each call requiring to read/derive everything,
        // since this data only changes on resize
        info: null,
        triggerTimeout: null
    };

    elements = {
        win: $(window)
    };

    fn = {
        init () {
            fn.updateInfo();
            fn.bindResizeEvent();
        },

        updateInfo () {
            const $win = elements.win;
            const width = $win.width();
            const height = $win.height();
            const breakpoint = fn.deriveBreakpoint(width);

            internal.info = {
                width: width,
                height: height,
                breakpoint: breakpoint
            };
        },

        bindResizeEvent () {
            elements.win.on('resize.layout', handlers.resize);
        },

        unbindResizeEvent () {
            elements.win.off('resize.layout');
        },

        deriveBreakpoint (width) {
            var b;

            $.each(breakpoints, function (i, breakpoint) {
                if (breakpoint.minWidth) {
                    if (width >= breakpoint.minWidth) {
                        if (breakpoint.maxWidth) {
                            if (width <= breakpoint.maxWidth) {
                                b = breakpoint;
                                return false;
                            }
                        } else {
                            b = breakpoint;
                            return false;
                        }
                    }
                } else if (breakpoint.maxWidth) {
                    if (width <= breakpoint.maxWidth) {
                        b = breakpoint;
                        return false;
                    }
                }
            });

            return b;
        },

        getInfo () {
            return internal.info;
        },

        onResize (handler) {
            return eventManager.addListener(eventTypes.RESIZE, handler);
        },

        offResize (handler) {
            return eventManager.removeListener(eventTypes.RESIZE, handler);
        },

        trigger () {
            fn.updateInfo();
            eventManager.emit(eventTypes.RESIZE, internal.info);

            fn.triggerNative();
        },

        triggerNative () {
            // trigger native resize event as a failsafe for more
            // complex computationals
            if (internal.triggerTimeout) {
                clearTimeout(internal.triggerTimeout);
                internal.triggerTimeout = null;
            }

            internal.triggerTimeout = setTimeout(function () {
                // ensure triggering the resize event doesn't
                // cause a stack overflow
                fn.unbindResizeEvent();

                elements.win.trigger('resize');
                fn.bindResizeEvent();

                fn.updateInfo();
                eventManager.emit(eventTypes.RESIZE, internal.info);
            }, 500);
        },

        breakpointIs (bpKey) {
            var breakpoint;
            breakpoint = internal.info.breakpoint;
            return breakpoint === breakpoints[bpKey];
        },

        hasTouchSupport () {
            return (('ontouchstart' in window) ||
                    (navigator.maxTouchPoints > 0) ||
                    (navigator.msMaxTouchPoints > 0));
        }
    };

    handlers = {
        resize: debounce(fn.trigger, 250)
    };

    self.breakpoints = breakpoints;

    self.eventTypes = eventTypes;
    self.breakpoints = breakpoints;

    self.getInfo = fn.getInfo;
    self.onResize = fn.onResize;
    self.offResize = fn.offResize;
    self.trigger = fn.trigger;
    self.breakpointIs = fn.breakpointIs;
    self.hasTouchSupport = fn.hasTouchSupport;

    fn.init();
};

export default new Layout();



// WEBPACK FOOTER //
// ./assets/js/services/layout.js